<template>
  <div id="main">
    <v-container>
      <v-row>
        <v-col cols="12" sm="12" md="12">
          <point-flow> </point-flow>
        </v-col>
        <v-col cols="12" sm="12" md="12">
          <transactions> </transactions>
        </v-col>
        <!-- <v-col-- cols="12" sm="12" md="12">
          <point-by-product></point-by-product>
        </v-col-->
      </v-row>
      <!-- row -->
    </v-container>
  </div>
</template>
<script>
import PointFlow from "./point-flow";
import Transactions from "./transactions";
//import PointByProducts from "./point-summary-by-product";

export default {
  name: "Dashboard",
  components: {
    "point-flow": PointFlow,
    transactions: Transactions,
    // "point-by-product": PointByProducts,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  computed: {},
};
</script>
